import type { WebsiteAnalyticsDays } from './types';

/** Auto-refresh interval for website activity dashboard (30–60s range). */
export const WEBSITE_ANALYTICS_REFETCH_INTERVAL_MS = 45_000;

export const WEBSITE_ANALYTICS_RECENT_LIMIT = 50;

export const WEBSITE_ANALYTICS_DEFAULT_DAYS: WebsiteAnalyticsDays = 7;

export const WEBSITE_ANALYTICS_DAY_OPTIONS: WebsiteAnalyticsDays[] = [7, 14, 30, 90];

export const WEBSITE_ANALYTICS_TOP_PAGES_LIMIT = 10;

/** Shared default limit for grouped list endpoints (top pages, sources). */
export const WEBSITE_ANALYTICS_GROUPED_LIST_LIMIT = WEBSITE_ANALYTICS_TOP_PAGES_LIMIT;
